import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import VideoFrame from '../Realizzazione/VideoFrame'
import VisibilitySensor from '../VisibilitySensor'
import Button from '@material-ui/core/Button'
import downloadIcon from './assets/images/download.svg'
import styles from './assets/styles/index.styles'
import FadeInHOC from '../FadeInHOC'
import { CollezionePageConfig } from '../../configuration'
import AssignId from '../AssignId'

const useStyles = makeStyles(styles)

export default function Collezione() {
    const classes = useStyles()
    return (
        <div>
            <div className={classes.root} >
                <AssignId
                    absolute
                    y='-80px'
                    yMobile='-50px'
                    id={CollezionePageConfig.slug}
                />
                <FadeInHOC seconds={2} >
                    <h1 className={classes.h1} >{CollezionePageConfig.title}</h1>
                </FadeInHOC>
                <VisibilitySensor index={8} />
                <FadeInHOC rootClass={classes.iframe} >
                    <VideoFrame id={CollezionePageConfig.videoID} noMarginTop />
                </FadeInHOC>
                <FadeInHOC rootClass={classes.ctaWrap} >
                    <p className={classes.p} >{CollezionePageConfig.cta[0]}</p>
					<span className={classes.span} >
						<a target='_blank' rel='noreferrer' className='MuiButtonBase-root MuiButton-root MuiButton-outlined jss193' variant='outlined' href={CollezionePageConfig.url[1]}><span class="MuiButton-label">{CollezionePageConfig.cta[1]}</span></a>
						<a target='_blank' rel='noreferrer' className='MuiButtonBase-root MuiButton-root MuiButton-outlined jss193' variant='outlined' href={CollezionePageConfig.url[2]}><span class="MuiButton-label">{CollezionePageConfig.cta[2]}<span class="MuiButton-endIcon MuiButton-iconSizeMedium"><img src="/affrescati/static/media/download.5d22b257.svg" alt="download icon"/></span></span></a>
					</span>
                </FadeInHOC>
            </div>
        </div>
    )
}
